import type { ReferenceTableRow } from '@repo/commons/models'

export type ReferenceTableRowCells = {
	id: string
	[key: string]: unknown
}

const COLUMN_KEY_PREFIX = 'column:'

export const toColumnKey = (columnName: string): string => `${COLUMN_KEY_PREFIX}${columnName}`

export const toRowCells = (
	row: ReferenceTableRow,
	index: number,
	columnNames: readonly string[]
): ReferenceTableRowCells => ({
	...Object.fromEntries(columnNames.map((name) => [toColumnKey(name), row[name] ?? null])),
	id: String(index)
})

const hasCellMatching = (cells: ReferenceTableRowCells, query: string): boolean =>
	Object.entries(cells).some(
		([key, value]) =>
			key.startsWith(COLUMN_KEY_PREFIX) &&
			String(value ?? '')
				.toLowerCase()
				.includes(query)
	)

export const filterRowCellsByQuery = <T extends ReferenceTableRowCells>(
	rows: readonly T[],
	searchQuery: string
): T[] => {
	const query = searchQuery.trim().toLowerCase()

	if (!query) return [...rows]

	return rows.filter((cells) => hasCellMatching(cells, query))
}
